"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderWidthSelector = borderWidthSelector;

var _escapeCss = require("../../escapeCss");

function borderWidthSelector(props, size) {
  var _props$theme, _props$theme$border, _props$theme$border$w;

  return (0, _escapeCss.escapeCss)((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$border = _props$theme.border) === null || _props$theme$border === void 0 ? void 0 : (_props$theme$border$w = _props$theme$border.width) === null || _props$theme$border$w === void 0 ? void 0 : _props$theme$border$w[size]);
}